import {EventEmitter, Injectable} from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: "root" 
})
export class ModuloService {

    public modulosEmitter = new EventEmitter<any>();
    //public modulosLateralEmitter = new EventEmitter<any>();

    constructor(private authService: AuthService,
        private _http: HttpClient,
        public utilitesService: UtilitesService) {
    }

    /**
     * Busca por ID
     * @param id
     * @returns {Observable<any>}
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "modulos/" + id, { headers: this.authService.getAuthHeaders()});
    }

    /**
     * Busca todos registros
     * @param params
     * @returns {Observable<any>}
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "modulos"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Busca todos registros
     * @param params
     * @returns {Observable<any>}
     */
    getAllByEmpresaId(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "modulos/empresa"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     *
     * @param lista
     */
    setEventListaEmmiter(lista:any){

        this.modulosEmitter.emit({modulos:lista});
        window.localStorage.setItem("modulos", JSON.stringify({modulos:lista}));
        //this.modulosLateralEmitter.emit({modulos:lista});
    }

    getModuloSession(){
        return window.localStorage.getItem("modulos");
    }

    getAllPermissoes(params: any): Observable<any>{
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }
        return this._http.get(this.utilitesService.urlPrefix + "modulos/permissoes"+env, { headers: this.authService.getAuthHeaders() });
    }

}